/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumnpeople3Inputs */

const en_downloadlinkscolumnpeople3 = /** @type {(inputs: Downloadlinkscolumnpeople3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

const de_downloadlinkscolumnpeople3 = /** @type {(inputs: Downloadlinkscolumnpeople3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Downloadlinkscolumnpeople3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumnpeople3 = /** @type {((inputs?: Downloadlinkscolumnpeople3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumnpeople3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumnpeople3(inputs)
	return de_downloadlinkscolumnpeople3(inputs)
});
export { downloadlinkscolumnpeople3 as "downloadLinksColumnPeople" }